import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionLongTextSchema = questionBaseSchema
  .extend({
    type: z.literal(QuestionType.LONG),
    points: z.number().positive('Punkty muszą być liczbą dodatnią'),
    answer: z.string().nullish(),
    minLength: z.number('Minimalna długość musi być liczbą').positive('Minimalna długość musi być liczbą dodatnią').optional(),
    maxLength: z.number('Maksymalna długość musi być liczbą').positive('Maksymalna długość musi być liczbą dodatnią').optional(),
  })
  .refine(
    (data) => {
      const { minLength, maxLength } = data;
      if (minLength === undefined || maxLength === undefined) {
        return true;
      } else if (minLength >= maxLength) {
        return false;
      }
      return true;
    },
    {
      message: 'Minimalna długość musi być mniejsza niż maksymalna długość',
      path: ['minLength'],
    }
  );

export type QuestionLongTextSchema = Infer<typeof questionLongTextSchema>;
